<template>
  <div>
    <b-col>
      <DragTable
        :url="url"
        ref="evidance_search"
        :dynamicButtons="buttonsIndicators"
        :keyLang="`exercise_design_evidance`"
        :order_url="$config.kanoon.evidence_order"
        :keyGroup="`exercise_design_id`"
        :order_by="`order:asc`"
        :permissionButtons="permissionButtons"
        :editRoute="true"
        :removeLabel="$lang.exercise_remove"
        :remove_item="removeEvidance"
        :hasAdd="isAdmin(permissions, ['admin'])"
        :extraButtons="extraButtons"
        @getPermisson="updatePermissions"
        @edit-item="editEvidance"
        @handleAdd="showAddEvidenceModal"
        @getOther="getOtherData"
      >
        <template slot="title-bar">
          <span v-html="title" />
        </template>
      </DragTable>
    </b-col>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_edit_evidance"
      size="xl"
      hide-header
      hide-footer
    >
      <AddEditEvidence
        :item="evidance"
        :evidance_exercise_id="exerciseDesignId"
        :viewMood="viewMood"
        @modal-close="evidanceModal"
        :valueIndicator="indicatorName"
      >
        <template slot="title-bar">
          <span v-html="title" />
        </template>
      </AddEditEvidence>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="evidance_sample_modal"
      size="xl"
      hide-header
      hide-footer
    >
      <DragTable
        :title="$lang.sample_evidence"
        :url="exercise_design_evidance_sample_url"
        ref="evidance_sample"
        :dynamicButtons="buttonsIndicators"
        :keyLang="`search_evidance_sample`"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
        :emptyText="$lang.dataNotExist"
      />
      <b-row>
        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="evidance_sample_modal = false"
            >
              <i class="fa fa-ban"></i>
              {{ $lang.close }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import DragTable from "@/components/base/dragTable";
import AddEditEvidence from "./../evidence/add_edit_evidence";
// import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl, goToRoute } from "@/shared/utils";

export default {
  name: "indicator-exercise-evidence",
  validations: {
    exercise_selected: {},
    indicator_selected: {},
  },
  components: {
    AddEditEvidence,
    DragTable,
    // LoadingSpinner,
  },
  data() {
    return {
      viewMood: "",
      evidance: null,
      nameIndicator: "",
      evidance_exercise_id: null,
      exerciseLoading: false,
      view_indicator_exercise: false,
      buttonsIndicators: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "sample_evidence",
          click: this.sample_evidence,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      view_edit_evidance: false,
      exercises: [],
      headers_fields: [],
      loading: false,
      filters: {},
      permissionButtons: [],
      exercise: "",
      exercise_type: "",
      itemClone: null,
      exercise_selected: null,
      exercise_Loading: false,
      exercise_options: [],
      indicator_selected: null,
      indicator_Loading: false,
      indicator_options: [],
      isCloneLoading: false,
      exercise_design_evidance_sample_url: null,
      evidance_sample_modal: false,
      permissions: [],
      cloneLoadingSpinnerText: this.$lang.receiving_data,
      deleteConfirm: {
        model: false,
        loading: false,
        description: this.$lang.are_you_sure_to_remove_item,
        itemId: null,
      },
      exerciseDesignId: +this.$route.params.id,
      otherData: [],
    };
  },
  computed: {
    title() {
      const indicatorType = pathOr(
        null,
        ["indicator", "value", "id"],
        this.otherData
      );
      const indicatorName = pathOr(
        "",
        ["indicator", "caption"],
        this.otherData
      );
      const exerciseId = pathOr("", ["exercise", "id"], this.otherData);
      const exerciseName = pathOr("", ["exercise", "caption"], this.otherData);

      return `
        ${this.$lang.indicator}: 
        <i 
          class="fa-lg fas fa-${
            indicatorType === 1 ? "plus text-success" : "minus text-danger"
          }"></i> ${indicatorName}
          <br/>
          <strong>${
            this.$lang.exercise
          } شماره ${exerciseId}: </strong>${exerciseName}`;
    },
    url() {
      return generateApiUrl(
        ["kanoon", "exercise_design_evidence"],
        [this.exerciseDesignId]
      );
    },
    extraButtons() {
      return [
        {
          name: "backComponentSearchFilter",
          condition: true,
          title: this.$lang.back,
          click: this.goToIndicatorEvidence,
          iconName: "reply",
        },
      ];
    },
    indicatorName() {
      return pathOr(null, ["indicator", "value", "caption"], this.otherData);
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    goToRoute,
    sample_evidence(item) {
      const exerciseId = pathOr(null, ["exercise", "id"], this.otherData);
      const indicatorId = pathOr(null, ["indicator", "id"], this.otherData);
      const evidenceId = pathOr(null, ["id"], item);

      this.exercise_design_evidance_sample_url = generateApiUrl(
        ["kanoon", "exercise_indicator_evidence_sample"],
        [exerciseId, indicatorId, evidenceId]
      );
      this.evidance_sample_modal = true;
    },
    editEvidance(item) {
      this.viewMood = `edit`;
      this.view_edit_evidance = true;
      this.evidance = item;
    },
    evidanceModal(val) {
      this.view_edit_evidance = val;
      this.$refs.evidance_search.fetchData();
    },
    removeEvidance(item) {
      const id = pathOr(null, ["id"], item);
      const url = generateApiUrl(["kanoon", "evidence_id"], [id]);
      return this.$httpService
        .delete(url)
        .then((response) => {
          this.$refs.evidance_search.fetchData();
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          return false;
        });
    },
    goToIndicatorEvidence() {
      const id = pathOr(null, ["indicator", "id"], this.otherData);
      const name = "indicator-evidence";
      const params = { id };
      goToRoute(name, params, {}, false);
    },
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
    showAddEvidenceModal() {
      this.view_edit_evidance = true;
      this.viewMood = "add";
    },
    getOtherData(data) {
      this.otherData = data;
    },
  },
};
</script>
